import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-fraude-modal',
  templateUrl: './error-fraude-modal.component.html',
  styleUrls: ['./error-fraude-modal.component.scss'],
})
export class ErrorFraudeModalComponent implements OnInit {
  description: string;
  title: string;

  constructor(
    private dialogRef: MatDialogRef<ErrorFraudeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataErrorIbanFaude,
    private router: Router,
  ) {
    this.description = this.data.description;
    this.title = this.data.title;
    this.showErrorIbanFraude();
  }
  closeErrorIntern() {
    this.router.navigate(['/demande-devis']);
    this.dialogRef.close();
  }
  showErrorIbanFraude(): boolean {
    const isErrors = this.description == '';
    return isErrors;
  }

  ngOnInit() {}
}
export interface DataErrorIbanFaude {
  description: string;
  title: string;
}
